const ITEMS = [
  "Gobierno corporativo",
  "Sucesión empresarial",
  "Auditoría y dictámenes",
  "Cumplimiento automatizado",
  "Estrategia fiscal",
  "Planeación patrimonial",
];

export default function Marquee() {
  // Duplicate the list so the loop is seamless
  const loop = [...ITEMS, ...ITEMS];

  return (
    <section
      data-testid="marquee-section"
      aria-label="Áreas de práctica"
      className="relative overflow-hidden border-y"
      style={{
        background: "linear-gradient(90deg, var(--rp-blue) 0%, var(--rp-green) 100%)",
        borderColor: "rgba(255,255,255,0.15)",
      }}
    >
      {/* edge fades */}
      <div
        className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10"
        style={{ background: "linear-gradient(90deg, rgba(71,118,185,1), rgba(71,118,185,0))" }}
      />
      <div
        className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10"
        style={{ background: "linear-gradient(-90deg, rgba(50,138,87,1), rgba(50,138,87,0))" }}
      />

      <div className="flex rp-anim-marquee py-5 sm:py-6 whitespace-nowrap">
        {loop.map((item, i) => (
          <div
            key={i}
            data-testid={`marquee-item-${i}`}
            className="flex items-center gap-6 px-8 shrink-0"
          >
            <span
              className="text-white/90 font-bold text-xl sm:text-2xl tracking-tight"
              style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
            >
              {item}
            </span>
            <span
              className="w-2.5 h-2.5 rounded-full"
              style={{ background: "rgba(255,255,255,0.55)" }}
              aria-hidden="true"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
